import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from './useSignupData';
import { GuessedPrefillHelperText } from '../views-components/GuessedPrefillHelperText';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { AnimatedHelperTextWrapper } from '../animation/Animations.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationTextWrapper = styled.div.withConfig({
  displayName: "useInputValidation__ValidationTextWrapper",
  componentId: "sc-1u74gt5-0"
})(["", ""], props => isCanvasTheme(props.theme) && `
    .is--text--error,
    > small {
      color: #bf2434 !important;
    }
    `);
export const useInputValidation = ({
  dataKey,
  customValidationError
}) => {
  const {
    isInvalid,
    errorMessage
  } = useSignupData(dataKey);
  const GuessedPrefillHelperTextElement = GuessedPrefillHelperText({
    dataKey
  });
  const {
    layoutType
  } = useLayoutTemplate();
  const isSidePanel = layoutType === LayoutType.SidePanel;
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.enrolled);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const getValidationText = () => {
    if (errorMessage && isInvalid && customValidationError) {
      return customValidationError;
    }
    if (errorMessage && isInvalid) {
      // short term solution
      const shouldShowDefaultMessaging = [Data.FirstName, Data.LastName].includes(dataKey) && !isValidI18nKey(errorMessage);
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx(ValidationTextWrapper, {
          children: /*#__PURE__*/_jsx(Small, {
            use: "error",
            weight: "regular",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              "data-selenium": `${dataKey}_validation_message`,
              message: shouldShowDefaultMessaging ? `data.${dataKey}.error.invalid` : errorMessage
            })
          })
        })
      );
    }
    if (isSidePanel && !GuessedPrefillHelperTextElement) {
      return null;
    }
    return /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: "500",
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        weight: "regular",
        children: GuessedPrefillHelperTextElement
      })
    });
  };
  const getValidationTextWrapper = () => {
    const validationHelperText = getValidationText();
    return validationHelperText && /*#__PURE__*/_jsx(AnimatedHelperTextWrapper, {
      isSidePanel: isSidePanel || isAssignedToACQ173VariantC || isAssignedToACQ173VariantA,
      children: validationHelperText
    });
  };
  return {
    getValidationText: getValidationTextWrapper
  };
};